/* eslint-disable max-lines */
"use client";

import { usePathname } from "next/navigation";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import React, { useState, useEffect, useRef } from "react";
// import ReactDOM from "react-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { CART, CHANGE_CURRENCY, CURRENCY_ID, LOTTIE_ICONS } from "../../../constants/common/common";
import { mobileIcons } from "../../../constants/common/headerToolbarConstants";
import { ROUTE_CONSTANTS } from "../../../constants/route";
import LocationLockStrip from "../../molecules/locationLock/LocationLockStrip";
import {
  requestToGetCurrency,
  requestToGetCurrencyFlagIcon,
  setCurrencyDrawerVisible,
} from "../../../store/slices/common/currencyLists";
import Typography from "../../atoms/typography";
import { initiateFus } from "../../../store/slices/common/fus";
import { unlockBody } from "../../../utils/document";
import { requestToFetchFnpCashBalance, requestToFetchFnpLabel } from "../../../store/slices/fnpCash";
import { requestToSavedAddress } from "../../../store/slices/savedAddresses";
import useAnalytics from "../../../analytics/useAnalytics";
import { formatClassNames, pageName } from "../../../utils/common";
import { cleverTapCommonEvents } from "../../../analytics/clevertapConstants";
import isEmpty from "lodash.isempty";
import { GA4_EVENTS, SOCIAL_LOGIN_KEY } from "../../../analytics/gaConstant";
import { setGA4LoginAndSignUp } from "../../../analytics/gaEvents";
import { requestToGetCustomerDetails } from "../../../store/slices/loginSignupSlice";
import { setIsMobileSearchVisibleAction } from "../../../store/slices/commonSlice";
import { getSessionStorage, removeSessionStorage } from "../../../utils/storage/sessionStorageUtil";
import { onClevertapPublish, getLottieIcons } from "../../../api/common";
import FNPIcon from "../header/fnpIcon";
import { execDataLayer } from "../../../utils/cache-layer/cacheLayer";
import { getInternationalDeliveryForRakhi } from "../../../api/locationLock";
import { getLocalStorageItem } from "../../../utils/storage/localStorageUtil";
import { requestToSetIcons } from "../../../store/slices/lottieIconsSlice";
import ButtonComponent from "../../atoms/button";
import { MY_GROUPS, NEW_GROUP } from "../../../constants/pageConstants/secretSanta";
import { requestToGetWebFeatureControls } from "../../../store/slices/webFeatureControls";
import { requestToFetchSpecialCountries } from "../../../store/slices/deliveryAddress";
import { responseGetCartItems } from "../../../store/slices/cartSlice";
import { ArrowLeftIcon, MagnifyingGlassIcon, ShoppingCartIcon } from "@phosphor-icons/react";
import { AnimatePresence, motion, useReducedMotion } from "motion/react";

/** Pill/icon swap timing as the PLP header collapses. */
const GIFT_FINDER_SWAP_TRANSITION = { duration: 0.2, ease: [0.32, 0.72, 0, 1] };

/** How far the launcher travels as it slides in or out, px. */
const GIFT_FINDER_SLIDE_PX = 10;

const MobileSearch = dynamic(() => import("../mobileSearch"), { ssr: false });
const AiGiftFinderIsland = dynamic(() => import("../../../containers/aiGiftFinder/views/AiGiftFinderIsland"), {
  ssr: false,
});
const Drawer = dynamic(() => import("../../molecules/drawer"), { ssr: false });
const CurrencyList = dynamic(() => import("../header/headerToolBar/headerComponents/currencyList"), { ssr: false });

/**
 *
 */
const HeaderPLPAndPDPMobile = ({
  isShowLocationLock,
  catalogId = "india",
  isShowIcons = true,
  isIntlMicrosite = false,
  isSecretSanta = false,
  parentClassName = "",
  categoryName = "",
  totalItems = 0,
  isFromPLP = false,
  serverSelectedCurrency,
  currencyListWithHeaders,
  // On by default, matching the search-bar surfaces. Pass false to suppress the icon.
  isGiftFinderEnabled = true,
  isSearchEnabled = true,
}) => {
  const dispatch = useDispatch();
  const { trackEvent, onUserLogin } = useAnalytics();
  const pathname = usePathname();
  const urlParams = new URLSearchParams(typeof window !== "undefined" ? window?.location?.search : "");
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isShowSearchPopUp, setIsShowSearchPopUp] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(serverSelectedCurrency?.currency?.id || CURRENCY_ID);
  const [hash, setHash] = useState("");
  const [isShowProductDetails, setIsShowProductDetails] = useState(false);
  const reduceMotion = useReducedMotion();
  const giftFinderVariant = isShowProductDetails || !isFromPLP ? "icon" : "pill";
  /** Enter/exit travel, flipped per direction so the swap mirrors on the way back. */
  const giftFinderSlidePx = giftFinderVariant === "icon" ? GIFT_FINDER_SLIDE_PX : -GIFT_FINDER_SLIDE_PX;
  const [maxWidthClass, setMaxWidthClass] = useState("");
  const {
    loginSignUp,
    loginDetail,
    cartCount,
    cartItems,
    checkLoginStatus,
    userSelectedCurrency,
    availableBalance,
    totalProducts,
  } = useSelector(
    (state) => ({
      loginSignUp: state?.loginSignUp,
      loginDetail: state?.fus?.loginDetail,
      cartCount: state.cart?.cartCount,
      cartItems: state.cart?.cartItems,
      checkLoginStatus: state.fus.loginDetail?.loggedin,
      userSelectedCurrency: state?.currencyList?.userSelectedCurrency,
      availableBalance: state.fnpCash?.availableBalance,
      totalProducts: state?.plp?.details?.total,
    }),
    shallowEqual,
  );

  const isHome = pathname === "/";
  const isPLP = pathname?.includes("-lp");
  const { product } = useSelector(
    (state) => ({
      product: state?.pdp?.clientCurrentClickedItem,
    }),
    shallowEqual,
  );
  const urlIdentifier = product?.urlIdentifier;

  const pageHeaderMenuData = {
    page_name: pageName(isHome, isPLP, pathname, urlIdentifier),
    pageType: (typeof window !== "undefined" && window.fnpPageType) || "",
    menu_name: null,
  };

  useEffect(() => {
    /** */
    const updateMaxWidth = () => {
      if (typeof window !== "undefined") {
        const width = window.innerWidth;
        if (width < 375) {
          setMaxWidthClass("max-w-[172px]");
        } else if (width >= 375 && width < 410) {
          setMaxWidthClass("max-w-[184px]");
        } else {
          setMaxWidthClass("max-w-[210px]");
        }
      }
    };
    updateMaxWidth();
    window.addEventListener("resize", updateMaxWidth);
    return () => window.removeEventListener("resize", updateMaxWidth);
  }, []);

  useEffect(() => {
    /** */
    const handleHashChange = () => {
      const newHash = window.location.href;
      setHash(newHash);
    };

    handleHashChange();

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  useEffect(() => {
    if (checkLoginStatus) {
      dispatch(requestToSavedAddress());
      dispatch(
        requestToFetchFnpCashBalance({
          isAgent: loginSignUp?.userDetails?.isAgentLogin,
          partyId: loginSignUp?.userDetails?.customerID,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkLoginStatus]);

  useEffect(() => {
    if (loginDetail?.loggedin) {
      dispatch(requestToGetCustomerDetails());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginDetail?.loggedin]);

  /**
   * This function fetches lottie icons from API and sets in redux store.
   * @async
   * @function fetchDynamicPlaceholder
   */
  const fetchLottieIcons = async () => {
    const lottieIcons = await execDataLayer(getLottieIcons, LOTTIE_ICONS);
    dispatch(requestToSetIcons(lottieIcons));
  };

  useEffect(() => {
    const isUserLoggedIn = loginDetail?.loggedin && !isEmpty(loginSignUp?.userDetails);
    if (isUserLoggedIn && (availableBalance || availableBalance === 0)) {
      const userDetails = { ...loginSignUp?.userDetails, userType: loginDetail?.userType };
      const isOAuth = loginDetail?.isOAuthUser;
      const storageItem = !!getSessionStorage(SOCIAL_LOGIN_KEY);
      const eventName = loginDetail?.userType === "Existing" ? GA4_EVENTS.LOGIN : GA4_EVENTS.SIGNUP;
      if (storageItem) {
        const publishCleverTapData = { profile: { identity: userDetails?.emailID, fnpCash: availableBalance } };
        onClevertapPublish(publishCleverTapData);
        const properties = setGA4LoginAndSignUp(userDetails, isOAuth);
        trackEvent(eventName, { ...properties }, ["ga4"]);
        onUserLogin({
          Site: {
            Identity: userDetails?.emailID,
            Email: userDetails?.emailID,
          },
        });
        if (loginDetail?.isNewUser) {
          const registrationData = {
            is_name_available: !!loginDetail?.fullname,
            is_phone_available: !isOAuth,
            is_email_available: true,
            login_source: isOAuth ? "Gmail" : "Email",
          };
          trackEvent("Registration Success", registrationData, ["clevertap"]);
        }
        trackEvent(
          cleverTapCommonEvents.loginSuccess,
          { loginSuccess: "Login Success", login_method: isOAuth ? "Gmail" : "Email" },
          ["clevertap"],
        );
        removeSessionStorage(SOCIAL_LOGIN_KEY);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginSignUp?.userDetails, loginDetail?.loggedin, availableBalance]);

  useEffect(() => {
    dispatch(requestToGetCurrency(currencyListWithHeaders));
    dispatch(requestToFetchFnpLabel());
    dispatch(initiateFus());
    dispatch(requestToGetCurrencyFlagIcon());
    dispatch(requestToGetWebFeatureControls());
    dispatch(requestToFetchSpecialCountries());
    fetchLottieIcons();

    const getIntDeliveryRakhiFromStorage = getLocalStorageItem("getIntDeliveryForRakhi");
    if (!getIntDeliveryRakhiFromStorage) {
      // Fetch and set the flag value in local storage
      (async () => {
        await execDataLayer(getInternationalDeliveryForRakhi, "getIntDeliveryForRakhi");
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (userSelectedCurrency?.currency?.id) {
      setSelectedCurrency(userSelectedCurrency?.currency?.id);
    }
  }, [userSelectedCurrency]);

  useEffect(() => {
    /**
     * Collapse the header once the filter-chip row reaches it.
     */
    const handleScroll = () => {
      const filterChips = document.getElementById("plpFilterChips");
      if (!filterChips) return;

      const bannerThresHold = 60;
      const filterOffset = filterChips.getBoundingClientRect();
      const filterOffsetTop = filterOffset?.top;

      if (filterOffsetTop <= Math.round(bannerThresHold) && categoryName) {
        setIsShowProductDetails(true);
        filterChips.classList.add("border-b-1");
      } else {
        setIsShowProductDetails(false);
        filterChips.classList.remove("border-b-1");
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    handleScroll();

    const resizeObserver = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(() => handleScroll());
    resizeObserver?.observe(document.body);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      resizeObserver?.disconnect();
    };
  }, [categoryName]);

  // Guards against refetching cart-items on every render: without this, an empty/stale
  // response keeps `cartItems` at length 0, which would re-trigger this effect and hammer
  // the cart-items API in a loop. Only retry once per new `cartCount`.
  const lastFetchedCartItemsForCountRef = useRef(null);

  useEffect(() => {
    if (
      cartCount > 0 &&
      (!Array.isArray(cartItems) || cartItems.length === 0) &&
      lastFetchedCartItemsForCountRef.current !== cartCount
    ) {
      lastFetchedCartItemsForCountRef.current = cartCount;
      dispatch(responseGetCartItems("Y"));
    }
  }, [cartCount, cartItems, dispatch]);

  /**
   * @function // OnChanging th header toolbar icons
   * @returns {void}
   */
  const onTabClick = (tabName) => {
    switch (tabName) {
      case "cart":
        window.location.href = `/${ROUTE_CONSTANTS.CHECKOUT}/${ROUTE_CONSTANTS.DELIVERY_ADDRESS}`;
        trackEvent(cleverTapCommonEvents.headerMenuClicked, { ...pageHeaderMenuData, menu_name: "cart" }, [
          "clevertap",
        ]);
        break;
      case "search":
        setIsShowSearchPopUp(true);
        dispatch(setIsMobileSearchVisibleAction(true));
        trackEvent(cleverTapCommonEvents.headerMenuClicked, { ...pageHeaderMenuData, menu_name: "Search" }, [
          "clevertap",
        ]);
        break;
      case "currency":
        setIsDropdownVisible(true);
        dispatch(setCurrencyDrawerVisible(true));
        trackEvent(cleverTapCommonEvents.headerMenuClicked, { ...pageHeaderMenuData, menu_name: "currency" }, [
          "clevertap",
        ]);
        break;
      default:
        break;
    }
  };
  /** Handle hiding dropdown when currency is selected */
  const handleCurrencySelect = (currency) => {
    setSelectedCurrency(currency); // Update the selected currency
    setIsDropdownVisible(false); // Hide the dropdown
    dispatch(setCurrencyDrawerVisible(false));
    unlockBody();
    onTabClick(null);
  };

  /**
   * Navigates back if referrer is from fnp domains, otherwise redirects to home.
   */
  const onHandleBack = () => {
    if (document.referrer && (document.referrer.includes("fnp.com") || document.referrer.includes("fnpplus.com"))) {
      window.history.back();
    } else {
      window.location.href = "/";
    }
  };

  /**
   * Closes the currency drawer and hides the dropdown.
   */
  const onDrawerClose = () => {
    dispatch(setCurrencyDrawerVisible(false));
    setIsDropdownVisible(false);
  };

  return (
    <>
      <div className={` left-0 top-0 z-50 flex w-full flex-col bg-white-900 ${parentClassName}`}>
        <div
          className={formatClassNames(
            "flex min-h-48 items-center justify-between gap-16 border-lightGrey px-16 py-6",
            isFromPLP && categoryName && "h-[50px] gap-4 overflow-hidden",
            isShowProductDetails ? "border-b-0" : "border-b-1",
          )}
        >
          <div
            className={formatClassNames(
              "flex max-w-fit items-center gap-8 overflow-hidden",
              isFromPLP && categoryName ? "w-[75%]" : "w-[60%] flex-1 pr-32",
            )}
          >
            {!isIntlMicrosite && (
              <div className="flex-none" onClick={onHandleBack}>
                <ArrowLeftIcon size={24} className="py-2 text-fnp-500" />
              </div>
            )}
            <div
              className={formatClassNames(
                "flex flex-col gap-20 transition-transform",
                isFromPLP &&
                  (isShowProductDetails
                    ? "translate-y-[-27px]"
                    : Number(totalProducts || totalItems) > 0
                      ? "translate-y-[28px]"
                      : categoryName
                        ? "translate-y-[24px]"
                        : ""),
              )}
            >
              <FNPIcon imgWidth={97} imgHeight={30} parentClasses="w-[97px]" />
              {categoryName && (
                <div className="flex items-center gap-8 py-1.5">
                  <FNPIcon imgWidth={18} imgHeight={23} isShowLogoWithoutText={true} parentClasses="w-[18px]" />
                  <div className={formatClassNames("flex flex-col", maxWidthClass)}>
                    <div className="truncate text-14 font-600 leading-5 text-fnp-500">{categoryName}</div>
                    {Number(totalProducts || totalItems) > 0 && (
                      <div className="text-12 font-400 leading-4 text-grey-400">
                        {totalProducts || totalItems} items
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
          {isShowIcons && (
            <div
              className={formatClassNames(
                "flex items-center justify-end gap-8",
                isShowProductDetails ? "w-[25%]" : "w-[40%] flex-1",
              )}
            >
              {isGiftFinderEnabled && (
                <div className="flex h-32 flex-none items-center">
                  <AiGiftFinderIsland
                    variant={giftFinderVariant}
                    iconSize={24}
                    launcherClassName={giftFinderVariant === "icon" ? undefined : "inline-flex h-32 flex-none px-4"}
                    isMobile={true}
                    catalogId={catalogId}
                    renderLauncher={(launcher) => (
                      <AnimatePresence initial={false} mode="wait">
                        <motion.div
                          key={giftFinderVariant}
                          initial={reduceMotion ? { opacity: 0 } : { opacity: 0, x: giftFinderSlidePx }}
                          animate={{ opacity: 1, x: 0 }}
                          exit={reduceMotion ? { opacity: 0 } : { opacity: 0, x: -giftFinderSlidePx }}
                          transition={GIFT_FINDER_SWAP_TRANSITION}
                          className="flex flex-none items-center"
                        >
                          {launcher}
                        </motion.div>
                      </AnimatePresence>
                    )}
                  />
                </div>
              )}
              {mobileIcons
                ?.filter((item) => isSearchEnabled || item.id !== "search")
                .map((item, index) => (
                  <div
                    key={index}
                    className={`relative flex cursor-pointer items-center justify-center`}
                    tabIndex="0"
                    id={item?.id}
                    onClick={() => onTabClick(item?.id)}
                  >
                    {item?.label === CART && cartCount > 0 && (
                      <span className="absolute  bottom-13 left-10 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-notification-secondary to-notification-primary p-4 text-12 text-white-900">
                        {cartCount}
                      </span>
                    )}
                    {item?.id === "search" && <MagnifyingGlassIcon size={24} className="py-2 text-fnp-500" />}
                    {item?.label === CART && <ShoppingCartIcon size={24} className="py-2 text-fnp-500" />}
                  </div>
                ))}
            </div>
          )}
          {isSecretSanta && hash.includes("#") && (
            <div className="flex gap-4">
              {checkLoginStatus && !hash?.includes("#dashboard") && !urlParams?.get("joinid") && (
                <div>
                  <ButtonComponent
                    size="textBtn"
                    label={MY_GROUPS}
                    buttonVariant="filter"
                    classes="py-10 px-12 text-red-700"
                    // eslint-disable-next-line react/jsx-handler-names
                    onClick={() => {
                      window.location.href = "/santa#dashboard";
                    }}
                  />
                </div>
              )}
              {!hash?.includes("#newRoom") && (
                <div>
                  <ButtonComponent
                    size="textBtn"
                    label={NEW_GROUP}
                    buttonVariant="filter"
                    classes="py-10 px-12 text-green-400"
                    buttonTextSize="medium"
                    // eslint-disable-next-line react/jsx-handler-names
                    onClick={() => {
                      window.location.href = "/santa#newRoom";
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </div>
        {isShowLocationLock && <LocationLockStrip isShowProductDetails={isShowProductDetails} />}
      </div>
      {isShowSearchPopUp && (
        <MobileSearch
          setShowSearchPopUp={setIsShowSearchPopUp}
          isShowSearchSec={isShowSearchPopUp}
          catalogId={catalogId}
          isSearchIconVisible={true}
          isGiftFinderEnabled={isGiftFinderEnabled}
        />
      )}
      <Drawer
        position="bottom"
        isOpen={isDropdownVisible}
        onDrawerClose={onDrawerClose}
        styles="px-16 max-h-[90vh] pb-0"
      >
        <div className="flex flex-col gap-8">
          <Typography Tag={"h4"} variant="h6" classes="text-16 font-600 mb-8 px-16">
            {CHANGE_CURRENCY}
          </Typography>
          <div className="mb-16 max-h-[calc(80vh-34px)] overflow-auto rounded-8 border-1" tabIndex="0">
            <CurrencyList setSelectedCurrency={handleCurrencySelect} selectedCurrency={selectedCurrency} />
          </div>
        </div>
      </Drawer>
    </>
  );
};

HeaderPLPAndPDPMobile.propTypes = {
  isShowLocationLock: PropTypes.bool,
  catalogId: PropTypes.string,
  // preloadLinks: PropTypes.array,
  isShowIcons: PropTypes.bool,
  isIntlMicrosite: PropTypes.bool,
  isSecretSanta: PropTypes.bool,
  parentClassName: PropTypes.string,
  categoryName: PropTypes.string,
  totalItems: PropTypes.number,
  isFromPLP: PropTypes.bool,
  serverSelectedCurrency: PropTypes.object,
  currencyListWithHeaders: PropTypes.object,
  isGiftFinderEnabled: PropTypes.bool,
  isSearchEnabled: PropTypes.bool,
};
export default React.memo(HeaderPLPAndPDPMobile);
